import type { AppDispatch } from "@src/store/rootState";
import { openDialog } from "@src/store/slices/global";

export type ConfirmResult = "confirm" | "cancel" | "close";

interface ConfirmOptions {
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  tertiaryText?: string;
  tertiaryAction?: () => void;
  tertiaryResolvesAs?: ConfirmResult;
  showCloseIcon?: boolean;
}

export async function confirm(
  dispatch: AppDispatch,
  options: ConfirmOptions
): Promise<ConfirmResult> {
  return new Promise<ConfirmResult>((resolve) => {
    dispatch(
      openDialog({
        dialog: "confirm",
        props: {
          title: options.title,
          message: options.message,
          confirmText: options.confirmText,
          cancelText: options.cancelText,
          tertiaryText: options.tertiaryText,
          showCloseIcon: options.showCloseIcon,
          confirmAction: () => resolve("confirm"),
          cancelAction: () => resolve("cancel"),
          closeAction: () => resolve("close"),
          tertiaryAction: () => {
            options.tertiaryAction?.();
            resolve(options.tertiaryResolvesAs ?? "cancel");
          },
        },
      })
    );
  });
}
